import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StandortService } from '../../services/standort.service';

export interface LabelPreviewData {
  indicator: any;
  standortId: string;
}

@Component({
  selector: 'app-label-preview-dialog',
  templateUrl: './label-preview-dialog.component.html',
  styleUrls: ['./label-preview-dialog.component.scss']
})
export class LabelPreviewDialogComponent implements OnInit {
  htmlContent: string = '';
  loading = true;
  error: string | null = null;
  // UI preview fields
  logoUrl: string = 'https://smarthcaap.tigersoft.at/assets/sbk1-logo.png';
  qrImgUrl: string = '';
  indicatorName: string = '';
  indicatorType: string = 'Indikator';
  indicatorNumber: string = '';
  colorHex: string = '#4CAF50';
  colorName: string = 'Grün';
  today: Date = new Date();

  constructor(
    public dialogRef: MatDialogRef<LabelPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LabelPreviewData,
    private standortService: StandortService,
    private snackBar: MatSnackBar,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    // prepare UI preview data
    const ind = this.data.indicator || {};
    this.indicatorName = ind.name || '';
    this.indicatorNumber = (ind.indikator_number != null ? ('#' + ind.indikator_number) : ('#' + (ind.id || '')));
    // Generate QR using Google Charts (matches backend approach)
    const qrData = encodeURIComponent(ind.id || '');
    this.qrImgUrl = `https://chart.googleapis.com/chart?chs=460x460&chld=L|0&cht=qr&chl=${qrData}`;
    // load server HTML (optional) for exact-print view
    this.loadLabelPreview();
  }

  loadLabelPreview(): void {
    this.loading = true;
    this.error = null;
    
    console.log('Loading label preview for indicator:', this.data.indicator);
    
    this.standortService.printQRIndicatorLabel(this.data.indicator.id).subscribe({
      next: (htmlContent: string) => {
        this.htmlContent = htmlContent;
        this.loading = false;
        console.log('Label preview loaded successfully');

        // Try to extract server-generated QR and logo from HTML for exact UI preview
        try {
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlContent, 'text/html');
          const qrImg = doc.querySelector('img.qr-code') as HTMLImageElement | null;
          const logoImg = doc.querySelector('img.logo') as HTMLImageElement | null;
          const clientIdEl = doc.querySelector('.client-id');
          if (qrImg && qrImg.src) {
            this.qrImgUrl = qrImg.src;
          }
          if (logoImg && logoImg.src) {
            this.logoUrl = logoImg.src;
          }
          if (clientIdEl && clientIdEl.textContent) {
            // Optional: override standortId display with parsed client id text
          }
        } catch (e) {
          console.warn('Failed to parse HTML for QR/logo extraction', e);
        }
      },
      error: (error) => {
        console.error('Error loading label preview:', error);
        this.error = 'Fehler beim Laden der Label-Vorschau';
        this.loading = false;
        this.snackBar.open('Fehler beim Laden der Label-Vorschau', 'Schließen', { duration: 5000 });
      }
    });
  }

  openInNewTab(): void {
    const base = this.standortService['apiUrl'].replace('/v5', '');
    const url = `${base}/debug-pdf-qr-indicator/${this.data.indicator.id}?debug_html=1`;
    window.open(url, '_blank');
  }

  printLabel(): void {
    if (!this.htmlContent) {
      this.snackBar.open('Keine Label-Daten verfügbar', 'Schließen', { duration: 3000 });
      return;
    }

    // Generate and download PDF
    this.standortService.generateQRIndicatorLabelPDF(this.data.indicator.id).subscribe({
      next: (pdfBlob: Blob) => {
        // Create blob and download
        const url = window.URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `qr-label-${this.data.indicator.name}-${new Date().toISOString().split('T')[0]}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        this.snackBar.open('PDF wird heruntergeladen', 'Schließen', { duration: 3000 });
      },
      error: (error) => {
        console.error('Error generating PDF:', error);
        this.snackBar.open('Fehler beim Generieren der PDF', 'Schließen', { duration: 5000 });
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
